module.exports = __webpack_public_path__ + "static/media/c++ icone.64b7d65a.png";